//******************************************************************************
// import
import { PathLayer } from "@deck.gl/layers";

//******************************************************************************
// レイヤIDを決めるためのプレフィックスと値生成関数
const getKey = () => {
	return `segments_${Date.now() + Math.random()}`;
};

//******************************************************************************
// export class
export class MeasureSegments {
	//**************************************************************************
	/**
	 * コンストラクタ
	 * @param	object	: color, width, unit
	*/
	constructor(opts) {
		//----------------------------------------------------------------------
		// 引数をメンバ変数に格納する
		this.opts = opts;
		//----------------------------------------------------------------------
		// optsを整理する
		const options = this.optimizeOpts();
		//----------------------------------------------------------------------
		// propsを構築する
		const props = {
			id: getKey(),
			data: [],
			getPath: d => d.path,
			getColor: options.color,
			getWidth: options.width,
			widthUnits: options.unit,
			pickable: true,
			material: false,
			parameters: {
				// depthWriteEnabled: false,
				depthCompare: "always",	//これを設定することで常に描画するようになる
			},
			// ここに記述してもonClickが効く
			// onClick: ( picking, event ) => {
			// }
		};
		//----------------------------------------------------------------------
		// レイヤを生成してメンバ変数に格納する
		this.layer = new PathLayer(props);
	}

	//**************************************************************************
	/**
	 * optsを整理する（一時的にoptsを変更する場合での使用を想定）
	 * @param {{color:Array<number>, width:number, unit:string}} opts 線の属性
	 * @returns {{color:Array<number>, width:number, unit:string}} 整理した属性
	*/
	optimizeOpts(opts) {
		//----------------------------------------------------------------------
		// 元のoptsを引数のoptsで上書きしたoptionsを作る
		const options = {
			...this.opts,
			...(opts || {}),
		};
		//----------------------------------------------------------------------
		// 線の色と幅と単位を決める
		const color = Array.isArray(options.color) ? options.color : [255, 0, 0];
		const width = typeof options.width !== "number" ? 2 : options.width;
		const unit = typeof options.unit === "undefined"
			? "pixels"
			: ["common", "pixels", "meters"].includes(options.unit) === false
				? "pixels"
				: options.unit;
		//----------------------------------------------------------------------
		// 整理したoptsを返す
		return { color, width, unit };
	}

	//**************************************************************************
	/**
	 * 現状のpropsを復元して返す
	 * @returns {Object}
	*/
	restoreProps() {
		//----------------------------------------------------------------------
		// 現状のpropsを取得して新しいpropsを作る
		const props = Object.fromEntries(
			Object.entries(this.layer.props)
		);
		//----------------------------------------------------------------------
		// idを更新しないと新しいデータで描画してくれない
		props.id = getKey();
		//----------------------------------------------------------------------
		// dataとmeshはgetterになっているのであらためてここで取得しておく
		props.data = this.layer.props.data;
		//----------------------------------------------------------------------
		// 復元したpropsを返す
		return props;
	}

	//**************************************************************************
	/**
	 * 線分の更新
	 * @param {[number, number, number]} vertex 経度、緯度、標高
	 * @param {number} index 指定ありなら対象決定、指定無しなら新規追加
	 * @returns	{this}
	*/
	update(vertex, index) {
		//----------------------------------------------------------------------
		// 現状のpropsを取得して新しいpropsを作る
		const props = this.restoreProps();
		//----------------------------------------------------------------------
		// indexで分岐
		if (typeof index === "undefined") {
			// 未指定の場合
			// データ未登録の場合は空のパスデータを追加
			if (props.data.length === 0) {
				props.data.push({
					path: []
				});
			}
			// 最後に登録したデータを取得
			const destination = props.data[props.data.length - 1];
			// データのpathの要素数が0または1の場合は座標を追加登録
			if (destination.path.length < 2) {
				destination.path.push(vertex.coordinates);
			}
			// pathの要素数が2になった場合は新たにパスデータを登録
			if (destination.path.length === 2) {
				// 新たに登録したパスデータには座標を最初から追加しておく
				props.data.push({
					path: [vertex.coordinates]
				});
			}
		} else {
			// 指定有りの場合
			// indexが0より大きい場合は前の線分の終点の座標を更新
			if (index > 0) {
				if (typeof props.data[index - 1] === "undefined") {
					console.log(props);
					console.log(index);
				}
				props.data[index - 1].path[1] = vertex.coordinates;
			}
			// この線分の始点の座標を更新
			props.data[index].path[0] = vertex.coordinates;
		}
		//----------------------------------------------------------------------
		// レイヤを再生成
		this.layer = new this.layer.constructor(props);
		//----------------------------------------------------------------------
		// 参照を返す
		return this;
	}

	//**************************************************************************
	/**
	 * データクリア
	 * @returns {this}
	*/
	clear() {
		//----------------------------------------------------------------------
		// 現状のpropsを取得して新しいpropsを作る
		const props = this.restoreProps();
		//----------------------------------------------------------------------
		// データを空にする
		props.data.length = 0;
		//----------------------------------------------------------------------
		// レイヤを再生成
		this.layer = new this.layer.constructor(props);
		//----------------------------------------------------------------------
		// 参照を返す
		return this;
	}

	//**************************************************************************
	/**
	 * レイヤを取得
	 * @return {Object} レイヤインスタンス
	*/
	getLayer() {
		//----------------------------------------------------------------------
		// レイヤインスタンスを返す
		return this.layer;
	}

	//**************************************************************************
	/**
	 * レイヤのコンストラクタ名を取得
	 * @return {string} レイヤインスタンスのコンストラクタ名
	*/
	getName() {
		//----------------------------------------------------------------------
		// レイヤのコンストラクタ名を返す
		return this.layer.constructor.name;
	}
};
